import { createInertiaApp, router } from '@inertiajs/react';
import { configureEcho } from '@laravel/echo-react';
import { SessionProvider } from '@onwardtravelsolutions/package-react/Components';
import { User } from '@onwardtravelsolutions/package-react/Types';
import { isSameUser } from '@onwardtravelsolutions/package-react/Utilities/users';
import Echo from 'laravel-echo';
import { createRoot } from 'react-dom/client';
import { Layout } from './Components';
import { AppErrorBoundary } from './Components/ErrorBoundaries';
import { EnvironmentContext } from './Contexts';

declare global {
    interface Window {
        Pusher: any;
        Echo: Echo<any>;
        Trustpilot: any;
    }
}

createInertiaApp({
    resolve: (name: string) => {
        const pages = import.meta.glob('./Pages/**/!(*.test).tsx', {
            eager: true,
        });
        let page = pages[`./Pages/${name}.tsx`];
        page.default.layout =
            page.default.layout ||
            ((page: any) => (
                <Layout env={page.props?.env} notices={page.props?.notices}>
                    {page}
                </Layout>
            ));
        return page;
    },
    setup({ el, App, props }) {
        const pageProps = props.initialPage.props as any;

        const handleFailedAuth = (
            requestedAs: User | null,
            actual: User | null,
        ) => {
            if (!actual || !requestedAs || !isSameUser(requestedAs, actual)) {
                window.location.href = pageProps.urls.home;
                return;
            }
        };

        createRoot(el).render(
            <AppErrorBoundary>
                <EnvironmentContext.Provider
                    value={{
                        recaptcha: pageProps.recaptcha,
                        environment: pageProps.env,
                        urls: pageProps.urls,
                    }}
                >
                    <SessionProvider
                        env={pageProps.env}
                        urls={pageProps.urls}
                        onForbidden={handleFailedAuth}
                        onUnauthorized={handleFailedAuth}
                        user={pageProps.user}
                    >
                        <App {...props} />
                    </SessionProvider>
                </EnvironmentContext.Provider>
            </AppErrorBoundary>,
        );
    },
    title: (title: string) => `${title} | Onward Travel Solutions`,
    progress: {
        color: '#29d',
        showSpinner: false,
    },
});

configureEcho({
    broadcaster: 'reverb',
});

router.on('navigate', () => {
    if (window.Trustpilot) {
        const widgets = document.getElementsByClassName('trustpilot-widget');
        for (const widget of widgets) {
            window.Trustpilot.loadFromElement(widget);
        }
    }
});
